import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import {
  GeneralSlice,
  generateInitialState,
  createGeneralSlice,
} from "./slices/generalSlice";
import {
  UserManagementSlice,
  createUserManagementSlice,
  userManagementInitialState,
} from "./slices/userManagementSlice";
import {
  PaymentSlice,
  createPaymentSlice,
  paymentInitialState,
} from "./slices/paymentSlice";

export type Store = GeneralSlice & UserManagementSlice & PaymentSlice;

export const initialState = {
  ...generateInitialState,
  ...userManagementInitialState,
  ...paymentInitialState,
};

const baseStore = create<Store>()(
  persist(
    (...a) => ({
      ...createGeneralSlice(...a),
      ...createUserManagementSlice(...a),
      ...createPaymentSlice(...a),
    }),
    {
      name: "general",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        activePath: state.activePath,
        theme: state.theme,
        loginHint: state.loginHint,
        languageSettings: state.languageSettings,
        showMenu: state.showMenu,
        showAppStoreFeature: state.showAppStoreFeature,
        userManagementUsers: state.userManagementUsers,
        navigationWidth: state.navigationWidth,
      }),
    },
  ),
);

export const useStore = createSelectorHooks(baseStore);
